import React from "react";
import AttributeList from "components/attributes/attribute-list";
import Loader from "components/loader/loader";

export const ProfilingAttributes = ({ isFinalized, isCompleted, attributes: definitions, reloadAttributes, isLoading, isBrandVerified }) => {
    if (isLoading && !definitions) {
        return (
            <div className="txt-center">
                <Loader natural={true} />
            </div>
        );
    }

    return (
        <div className="attribute-table">
            <AttributeList
                isCompleted={isCompleted}
                isFinalized={isFinalized}
                attributeGroups={definitions.groups}
                attributesSubgroups={definitions.subGroups}
                removeAttribute={reloadAttributes}
                reloadAttributes={reloadAttributes}
                readOnlyOverride={false}
                taskType={"scheduling.default"}
                isBrandVerified={isBrandVerified}
            />
        </div>
    );
};
